<template>
  <div class="mask" v-if="dialogVisible">
    <div class="confirmation" :style="`width:${confirmationWidth}`">
      <p class="p_1">
        <img v-if="icon ? false : true" :src="img" alt="" />
        <svg-icon class="svg-icon" :style="iconStyle" v-if='icon ? true : false' :name='icon'></svg-icon>
        <!-- img -->
        <slot name="title"></slot>
        <span v-text="title" :style='p1Style'></span>
        <span @click="cancel" class="dialog-close">
          <svg-icon class="svg-icon-close" name='close' style="color: #C4C4C4;" v-if='isShowRightClose'></svg-icon>
        </span>
      </p>
      <p v-if="content" class="p_2" :style="`width:${p2Width}px`">
        <slot v-if="content === '#slot'" name="content"></slot>
        <template v-else>
          {{ content }}
        </template>
      </p>
      <slot></slot>
      <slot name="footer">
        <p class="p_3">
          <template v-if="showCommon">
            <common-button size="small" @click="cancel" v-if="showCancel">CANCEL</common-button>
            <common-button :loading="loading" type="primary" size="small" @click="confirm">{{ confirmContent2.toUpperCase() }}</common-button>
          </template>
          <span v-if="isCancel" :class="status ? 'cancelTextBtn' : 'cancelBtn'" @click="cancel">CANCEL</span>
          <common-button v-if="!showCommon && showCommonCancel" size="small" @click="cancel">{{cancelContent}}</common-button>
          <el-button
            v-if="!showCommon"
            :loading="loading"
            :style="'background:' + typeColor"
            class="confirmBtn"
            :disabled="disabled"
            size="small"
            @click="confirm"
          >
            {{ confirmContent.toUpperCase() }}
          </el-button>
        </p>
      </slot>
    </div>
  </div>
</template>

<script>

import appendToDom from "@/components-v3/mixins/append-to-dom"

export default {
  mixins: [appendToDom()],
  data() {
    return {};
  },
  props: {
    showCommon: {
      type: Boolean,
      default: false
    },
    showCommonCancel: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "Delete Confirmation",
    },
    content: {
      type: String,
      default: "Are you sure you want to delete selected item?",
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    confirmContent: {
      type: String,
      default: "DELETE",
    },
    confirmContent2: {
      type: String,
      default: "YES",
    },
    cancelContent: {
      type: String,
      default: "CANCEL",
    },
    typeColor: {
      type: String,
      default: "#cf1322",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    img: {
      default: require("../images/delete2.svg"),
    },
    status: {
      type: String,
      default: ''
    },
    isCancel: {
      type: Boolean,
      default: true,
    },
    confirmationWidth: {
      type: String,
      default: "400px",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ''
    },
    isShowRightClose: {
      type: Boolean,
      default: false
    },
    p2Width: {
      type: String,
      default: 'auto'
    },
    iconStyle: {
      type: String,
      default: ''
    },
    p1Style: {
      type: String,
      default: 'width: auto'
    }
  },
  methods: {
    cancel() {
      this.$emit("update:dialogVisible", false);
      this.$emit("cancel");
    },
    confirm() {
      console.log(123123123111111)
      this.$emit("confirm");
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.mask {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2006;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.65);
  .confirmation {
    width: 400px;
    // height: 182px;
    padding: 24px;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 2px 10px 0 rgba(70, 83, 106, 0.2);
    .p_1 {
      display: flex;
      position: relative;
      margin-bottom: 4px;
      // align-items: center;
      // margin: 32px 0 5px 0;

      img {
        margin-right: 8px;
        height: 24px;
      }
      .svg-icon {
        margin-right: 8px;
        height: 24px;
        width: 24px;
      }
      .svg-icon-close {
        position: absolute;
        right: 0px;
        cursor: pointer;
      }
      span {
        font-family: OpenSans-Bold, sans-serif;
        font-size: 16px;
        color: #000000;
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      .dialog-close{
        align-items: flex-start;
        justify-content: center;
        .svg-icon{
          margin-right: 0;
        }
      }
    }
    .p_2 {
      font-weight: 500;
      font-size: 12px;
      color: #7F8596;
      margin-left: 34px;
      margin-bottom: 20px;
      font-family: OpenSans, sans-serif;
      
    }
    .p_3 {
      float: right;
      /*button:nth-child(1) {*/
      /*color: #666666;*/
      /*background-color: #eceef1;*/
      /*}*/
      /*button:nth-child(2) {*/
      /*color: #fff;*/
      /*}*/

      span {
        cursor: pointer;
        display: inline-block;
        padding: 5px 16px;
        line-height: 20px;
        font-weight: 500;
        font-size: 12px;
      }
    }
  }
  .cancelTextBtn {
    margin-right: 16px;
    padding: 5px 10px;
    color: #4c556c;
    border-radius: 4px;
    font-family: OpenSans;
    font-weight: 700;
    font-size: 12px;
    line-height: 22px;
    &:hover {
      background-color: #e9eaed;
    }
  }
  .cancelBtn {
    // margin-right: 16px;
    height: 32px;
    padding: 5px 10px;
    color: #4c556c;
    font-weight: 700 !important;
    font-size: 12px;
    line-height: 22px;
    border-radius: 4px;
    font-family: OpenSans;
    background-color: #ffffff;
    border: 1px solid #B4BAC8;
  }
  .confirmBtn {
    // padding: 6px 10px;
    height: 32px;
    padding-top: 0;
    padding-bottom: 0;
    color: #ffffff;
    border-radius: 4px;
    border: 0;
    margin-left: 16px;
    font-weight: 700;
    font-size: 12px;
    line-height: 22px;
    &:hover {
      opacity: 0.8;
    }
    ::v-deep span {
      font-family: OpenSans;
      font-size: 12px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}
</style>
